import { render, staticRenderFns } from "./allacciatura.vue?vue&type=template&id=52e31191&"
import script from "./allacciatura.vue?vue&type=script&lang=js&"
export * from "./allacciatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports